import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../app/hooks";
import Header from "../../../components/header/Header";
import Loading from "../../../components/Loading/Loading";
import { selectedProject } from "../../home/appSlice/appslice";
import {
  useGetAExperienceByIdQuery
} from "../api/experienceCardApiSlice";
import ExperienceMainDetailsContainer from "../container/experience.details.container/experience.main.details.container";
import { useLocation } from "react-router-dom";

const ExperienceDetailsPage = () => {
  const { status } = useParams()
  const navigate = useNavigate()
  const projectApp = useAppSelector(selectedProject)
  const location = useLocation();
  
  
  const isPrerequisites = location.state.isPrerequisites
  const lastPosition = location.state.lastPosition
  
  useEffect(() => {
    if (!projectApp) {
      navigate('/')
    }
  }, [projectApp])
  
  const {
    data: experienceDetails,
    isLoading,
    isSuccess,
    isError,
  } = useGetAExperienceByIdQuery(status!);
  
 

  let content
  if (isLoading || isLoading) {
    content = (
      <>
        <Header title="Experience Datails" />
        <Loading />
      </>
    )
  } else if (isSuccess) {
    content = (
      <>
        <Header title="Experience Datails" />
        {isSuccess && (
          <ExperienceMainDetailsContainer

            experienceDtails={isPrerequisites ? undefined : experienceDetails?.entities[status!]}
            isUpdated={true}
            isPrerequisites={isPrerequisites}
            prerequisiteID={status}
            lastPosition={lastPosition}

          />
        )}
      </>
    )
  } else if (isError) {
    content = <ExperienceMainDetailsContainer isUpdated={false} isPrerequisites={false} />
  }

  return <>{content}</>
}

export default ExperienceDetailsPage
